import React from 'react';
import Button from '../Button/button.component';
import { SearchInputStyle } from './searchbar.style';

const Searchbar = ({
	onSubmit, name, placeholder, onChange, onKeyPress, onClick, value, searchTypeHandler,
}) => (
	<React.Fragment>
		<form onSubmit={onSubmit}>
			<div className='input-group'>
				<SearchInputStyle
					type='search'
					className='form-control'
					name={name}
					value={value || ''}
					placeholder={placeholder}
					aria-label={placeholder}
					aria-describedby='basic-addon2'
					onChange={onChange}
					onKeyPress={onKeyPress}
				/>
				<div className='input-group-append'>
					<Button
						primary
						type='button'
						icon='fas fa-search'
						className='input-group-text m-0'
						onClick={onClick}
					/>
				</div>
			</div>
		</form>
		{searchTypeHandler
		&& (
			<button
				className='btn btn-link float-left mt-2 pl-0'
				type='button'
				onClick={() => searchTypeHandler()}
			>Pesquisa avançada
			</button>
		)}
	</React.Fragment>
);

export default Searchbar;
